import { FC } from "react";
import { CommonProjectForm } from "./CommonProjectForm";

export const CreateProjectForm: FC = () => {
	return (
		<CommonProjectForm
			projectId={undefined}
			projectType="construction-site"
			constructionSiteFullDetails={undefined}
		/>
	);
};
